<script>
import { mapActions } from 'vuex'
import { MessageBox } from 'element-ui'

export default {
  methods: {
    ...mapActions('files', [
      'deleteFile'
    ]),
    ...mapActions('filesFolder', [
      'deleteFolder'
    ]),
    multipleFilesDelete (files) {
      const folder = files.findIndex(file => {
        return file.type === 5
      })
      const nonFolder = files.findIndex(file => {
        return file.type !== 5
      })
      let message
      if (folder > -1 && nonFolder > -1 && files.length > 1) {
        message = `This will permanently delete ${files.length} selected files, folders and ALL files inside folders. Continue?`
      } else if (folder > -1 && nonFolder === -1 && files.length > 1) {
        message = `This will permanently delete ${files.length} selected folders and ALL files inside folders. Continue?`
      } else if (folder === -1 && nonFolder > -1 && files.length > 1) {
        message = `This will permanently delete ${files.length} selected files. Continue?`
      } else if (nonFolder > -1 && files.length === 1) {
        message = `This will permanently delete selected file. Continue?`
      } else {
        message = `This will permanently delete selected folder and ALL files inside folder. Continue?`
      }
      MessageBox.confirm(message, 'Delete multiple files', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        center: true
      }).then(() => {
        files.forEach(file => {
          if (file.type === 5) {
            this.deleteFolder(file)
          } else {
            this.deleteFile(file)
          }
        })
      }).catch(() => {})
    },
    fileDelete (file) {
      let message
      if (file.type === 5) {
        message = 'This will permanently delete the folder and ALL files inside. Continue?'
      } else {
        message = 'This will permanently delete the file. Continue?'
      }
      MessageBox.confirm(message, file.name, {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        center: true
      }).then(() => {
        if (file.type === 5) {
          this.deleteFolder(file)
        } else {
          this.deleteFile(file)
        }
      }).catch(() => {})
    }
  }
}
</script>
